<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      
      <el-form-item  prop="userId" v-show="adminShow">
        <el-select v-model="queryParams.userId" filterable :placeholder="$t('app.taskCenter.agent')" @change="agentsearch" clearable v-if="adminShow">
          <el-option v-for="(item,index) in agent" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="beassignUserId">
        <el-select v-model="queryParams.beassignUserId" filterable :placeholder="$t('app.taskCenter.assignedAgent')" @change="search" clearable>
          <el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="missionType">
        <el-select v-model="queryParams.missionType" filterable :placeholder="$t('app.common.type')" @change="search" clearable>
          <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable :placeholder="$t('app.common.status')" @change="search" clearable>
          <el-option v-for="item in state" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="iccid" >
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          :start-placeholder="$t('app.common.startDate')"
          :end-placeholder="$t('app.common.endDate')"
        ></el-date-picker>
      </el-form-item>
      <el-form-item  prop="missionId" v-show="adminShow">
        <el-input v-model="queryParams.missionId" :placeholder="$t('app.taskCenter.missionId')"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="username" v-show="adminShow">
        <el-input v-model="queryParams.username" :placeholder="$t('app.taskCenter.operator')"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border :loading="loading">
      <el-table-column type="index" :label="$t('app.common.serialNumber')" align="center" width="60px"></el-table-column>
      <el-table-column prop="missionId" :label="$t('app.taskCenter.table.missionId')" align="center" width="100px"  :show-overflow-tooltip="true">
        <template  slot-scope="scope">
          <template v-if="adminShow">
            <el-link v-if="!!scope.row.missionId && scope.row.missionType =='卡分配' " type="primary" :underline="false" @click="direct(scope.row)">{{ scope.row.missionId }}</el-link>
            <span v-else>{{scope.row.missionId}}</span>
          </template>
          <template v-else>
            {{scope.row.missionId}}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="companyName" :label="$t('app.taskCenter.table.agent')" align="center" width="260px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="receiverCompanyName" :label="$t('app.taskCenter.table.assignedAgent')" align="center" width="160px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="missionType" :label="$t('app.common.type')" align="center" width="100px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="cardStartValue" :label="$t('app.taskCenter.table.startSegment')" align="center" width="185px"></el-table-column>
      <el-table-column prop="cardEndValue" :label="$t('app.taskCenter.table.endSegment')" align="center" width="185px"></el-table-column>
      <el-table-column prop="percent" :label="$t('app.taskCenter.table.progress')" align="center" width="180px">
        <template slot-scope="{row}">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="row.percent"></el-progress>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.taskCenter.table.progressDetail')" min-width="120px" align="center">
        <template slot-scope="{row}">
            {{row.successNumber}}/{{row.totalNumber}}
        </template>
      </el-table-column>
      <el-table-column prop="status" :label="$t('app.common.status')" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status == '1'">{{ $t('app.taskCenter.status.unfinished') }}</el-tag>
          <el-tag v-else-if="row.status == '0'" type="info">{{ $t('app.taskCenter.status.processing') }}</el-tag>
          <el-tag v-else type="success">{{ $t('app.taskCenter.status.completed') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" :label="$t('app.common.createTime')" align="center" width="160px"></el-table-column>
      <el-table-column prop="createUser" :label="$t('app.taskCenter.table.operator')" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column :label="$t('app.common.operation')" align="center" min-width="250px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" plain icon="el-icon-delete" @click="deleteRow(scope.row)"  v-hasPermi="['taskCenter:delete']">删除</el-button>
          <el-button size="mini" type="success" plain icon="el-icon-download" @click="down(scope.row)" v-if="scope.row.isDown == '1'" v-hasPermi="['taskCenter:down']">下载</el-button>
          <el-dropdown v-if="adminShow" @command="(command) => handleCommand(command, scope.row)">
            <span class="el-dropdown-link">
              <i class="el-icon-d-arrow-right el-icon--right"></i>{{ $t('app.common.more') }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="info" icon='el-icon-guide'>{{ $t('app.common.detail') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />

    <el-dialog title="任务详情" :visible.sync="open" width="600px" append-to-body>
      <el-descriptions class="margin-top" :title="workTitle" :column="1" size="medium " border>
        <el-descriptions-item v-for="item in infoData" :key="item.id">
          <template slot="label">
            {{item.columnName}}
          </template>
          <el-input
            type="textarea"
            autosize
            disabled
            v-model ="item.columnValue">
          </el-input>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import { missionList ,agentList ,agentChildList,deleteTask} from "@/api/api.js"; //任务中心列表
import { requestLogList} from "@/api/api.js"; //任务中心列表
export default {
  data() {
    return {
      queryParams:{
        username:undefined,
        missionId:undefined,
        userId:undefined,
        beassignUserId:undefined,
        missionType:undefined,
        status:undefined,
        iccid:undefined,
      },
      agent:[],
      agentList:[],
      // 日期范围
      dateRange: [],
      open:false,
      workTitle:'',
      type: [
        { value: "1",label: this.$t('app.taskCenter.type.cardAllocation')},
        { value: "2",label: this.$t('app.taskCenter.type.cardRecovery')},
        { value: "3",label: this.$t('app.taskCenter.type.batchRecharge')},
        { value: "4",label: this.$t('app.taskCenter.type.cardImport') },
        { value: "5",label: this.$t('app.taskCenter.type.flowCardExport')}, 
        { value: "6",label: this.$t('app.taskCenter.type.orderExport')},
        { value: "7",label: this.$t('app.taskCenter.type.commissionExport')},
        { value: "8",label: this.$t('app.taskCenter.type.rechargeExport')},
        { value: "9",label: this.$t('app.taskCenter.type.cardReissueExport')},
        { value: "10",label: this.$t('app.taskCenter.type.balanceRecharge')},
        { value: "11",label: this.$t('app.taskCenter.type.flowPoolAllocation')},
        { value: "12",label: this.$t('app.taskCenter.type.flowPoolRecovery')},
        { value: "13",label: this.$t('app.taskCenter.type.billDetail')},
        { value: "14",label: this.$t('app.taskCenter.type.flowCardSettingExport')},
        { value: "15",label: this.$t('app.taskCenter.type.operationDataExport')},
        { value: "16",label: this.$t('app.taskCenter.type.qrCodeExport')},
        { value: "17",label: this.$t('app.taskCenter.type.alipayBatchRecharge')},
        { value: "18",label: this.$t('app.taskCenter.type.wechatBatchRecharge')},
        { value: "19",label: this.$t('app.taskCenter.type.agentAutoRenewal')},
        { value: "20",label: this.$t('app.taskCenter.type.riskCardImport')},
        { value: "21",label: this.$t('app.taskCenter.type.riskCardExport')},
        { value: "22",label: this.$t('app.taskCenter.type.riskCardRemoveImport')},
        { value: "23",label: this.$t('app.taskCenter.type.canceledCardImport')},
        { value: "24",label: this.$t('app.taskCenter.type.canceledCardRemoveImport')},
        { value: "25",label: this.$t('app.taskCenter.type.canceledCardExport')},
        { value: "26",label: this.$t('app.taskCenter.type.cardClear')},
        { value: "27",label: this.$t('app.taskCenter.type.withdrawalCommissionExport')},
        { value: "28",label: this.$t('app.taskCenter.type.cardAllocationRecordExport')},
        { value: "29",label: this.$t('app.taskCenter.type.flowPoolConsumptionRecordExport')},
        { value: "30",label: this.$t('app.taskCenter.type.flowPoolMemberInfoExport')},
        { value: "31",label: this.$t('app.taskCenter.type.userConsumptionRecordExport')},
        { value: "32",label: this.$t('app.taskCenter.type.flowCardHistoricalDataExport')},
        { value: "43",label: this.$t('app.taskCenter.type.abnormalCardStatusExport')},
      ],
      agentType:[
        { value: "1",label: this.$t('app.taskCenter.type.cardAllocation')},
        { value: "2",label: this.$t('app.taskCenter.type.cardRecovery')},
        { value: "6",label: this.$t('app.taskCenter.type.orderExport')},
        { value: "7",label: this.$t('app.taskCenter.type.commissionExport')},
        { value: "10",label: this.$t('app.taskCenter.type.balanceRecharge')},
        { value: "17",label: this.$t('app.taskCenter.type.alipayBatchRecharge')},
        { value: "18",label: this.$t('app.taskCenter.type.wechatBatchRecharge')},
        { value: "19",label: this.$t('app.taskCenter.type.agentAutoRenewal')},
      ],
      agentPoolType:[
        { value: "17",label: this.$t('app.taskCenter.type.alipayBatchRecharge')},
        { value: "18",label: this.$t('app.taskCenter.type.wechatBatchRecharge')},
        { value: "29",label: this.$t('app.taskCenter.type.flowPoolConsumptionRecordExport')},
      ],
      state:[
        {
          value: "1",
          label:  this.$t('app.taskCenter.status.unfinished')
        },
        {
          value: "0",
          label: this.$t('app.taskCenter.status.processing')
        },
        {
          value: "2",
          label: this.$t('app.taskCenter.status.completed')
        },
      ],
      page: 1,
      pageSize: 20,
      total: 0,
      tableData:[],
      infoData:[],
      timer:null,
      loading: false,
      debounceTimer: null,
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
    commissionMode(){
      return this.$store.getters.user.userCommissionType
    }
  },
  methods: {
    operationType(status) {
      let obj = {
        1: this.$t('app.taskCenter.type.cardAllocation'),
        2: this.$t('app.taskCenter.type.cardRecovery'),
        3: this.$t('app.taskCenter.type.batchRecharge'),
        4: this.$t('app.taskCenter.type.cardImport'),
        5: this.$t('app.taskCenter.type.flowCardExport'),
        6: this.$t('app.taskCenter.type.orderExport'),
        7: this.$t('app.taskCenter.type.commissionExport'),
        8: this.$t('app.taskCenter.type.rechargeExport'),
        9: this.$t('app.taskCenter.type.cardReissueExport'),
        10: this.$t('app.taskCenter.type.balanceRecharge'),
        11: this.$t('app.taskCenter.type.flowPoolAllocation'),
        12: this.$t('app.taskCenter.type.flowPoolRecovery'),
        13: this.$t('app.taskCenter.type.billDetail'),
        14: this.$t('app.taskCenter.type.flowCardSettingExport'),
        15: this.$t('app.taskCenter.type.operationDataExport'),
        16: this.$t('app.taskCenter.type.qrCodeExport'),
        17: this.$t('app.taskCenter.type.alipayBatchRecharge'),
        18: this.$t('app.taskCenter.type.wechatBatchRecharge'),
        19: this.$t('app.taskCenter.type.agentAutoRenewal'),
        20: this.$t('app.taskCenter.type.riskCardImport'),
        21: this.$t('app.taskCenter.type.riskCardExport'),
        22: this.$t('app.taskCenter.type.riskCardRemoveImport'),
        23: this.$t('app.taskCenter.type.cancelCardImport'),
        24: this.$t('app.taskCenter.type.cancelCardRemoveImport'),
        25: this.$t('app.taskCenter.type.cancelCardExport'),
        26: this.$t('app.taskCenter.type.cardClear'),
        27: this.$t('app.taskCenter.type.withdrawCommissionExport'),
        28: this.$t('app.taskCenter.type.cardAllocationRecordExport'),
        29: this.$t('app.taskCenter.type.flowPoolConsumptionExport'),
        30: this.$t('app.taskCenter.type.flowPoolMemberExport'),
        31: this.$t('app.taskCenter.type.userConsumptionExport'),
        32: this.$t('app.taskCenter.type.flowCardHistoryExport'),
        43: this.$t('app.taskCenter.type.cardStatusAbnormalExport')
      };
      return obj[status];
    },
    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "info":
          this.info(row);
          break;
        default:
          break;
      }
    },
    agentsearch(){
      this.debounce(() => {
        if(!this.queryParams.userId){
          this.queryAgentList()
          return 
        }
        let params ={
          userId:this.queryParams.userId
        }
        agentChildList(params).then(res => {
          this.agentList = res.data.data
        }).catch(err => {
            console.error('获取子代理商列表失败:', err);
        })
      }, 300);
    },
    initData() {
      if (this.loading) return;
      this.loading = true;
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      missionList(params).then(res => {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
      }).catch(err => {
          console.error('获取任务列表失败:', err);
      }).finally(() => {
          this.loading = false;
      })
    },
    //代理商下拉列表
    queryAgentList() {
      agentList().then(res => {
        if (res.data.code == 200) {
          this.agent = res.data.data;
          this.agentList = res.data.data;
        }
      }).catch(err => {
          console.error('获取代理商列表失败:', err);
      });
    },
    // 下载
    down(row){
      let url = process.env.VUE_APP_BASE_API + '/mission/down?id=' + row.id + '&token=' + getToken();
      window.location.href = url;
    },
    // 搜索
    search(){
      this.page = 1;
      this.debounce(() => {
        this.initData();
      }, 300);
    },
    // 重置
    resetQuery(){
      this.dateRange = [];
      this.resetForm("queryForm");
      this.queryAgentList();
      this.initData();
    },
    deleteRow(row){
        this.$confirm('此操作将永久删除该记录和文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTask({id:row.id}).then(res=>{
            if(res.data.code == 200){
                this.initData();
            }else{
              this.$message.error('删除失败');
            }
        }).catch(err => {
            console.error('删除任务失败:', err);
            this.$message.error('删除失败');
        });
        })

    },
    direct(row){
      this.$router.push({name:'distribution',params:{missionId : row.missionId}});
    },
    info(row){
      this.open = true;
      this.workTitle = "业务号："+ row.missionId
      this.handleRequestLog(row.missionId);
    },
    // 取消按钮
    cancel() {
      this.open = false;
    },
    handleRequestLog(workId){
      requestLogList({'workId':workId}).then(res=>{
        this.infoData = res.data.data;
      }).catch(err => {
          console.error('获取任务日志失败:', err);
      })
    },
    // 清理定时器
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    },
    // 防抖函数
    debounce(func, delay) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        func();
      }, delay);
    }
  },
  // 监听路由离开的操作
  beforeRouteLeave(to, form, next) {
    this.clearTimer();
    next()
  },
  // 组件销毁时清理资源
  beforeDestroy() {
    this.clearTimer();
  },
  mounted() {
    this.timer = setInterval(() => {
      this.initData();
    }, 3500);

  },
  created() {
    
    if(!this.adminShow){
      if(this.commissionMode == '2'){
        this.type = this.agentPoolType;
      }else{
        this.type = this.agentType
      }
    }
    
    this.initData();
    this.queryAgentList()
  }
};
</script>
<style scoped lang="less">
 	
</style>


